import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { forEach } from 'lodash'
import { ProductItem } from '../../components/ProductItem'
import { useStoreView } from 'hooks/useStoreView'
import { useCustomer } from 'lib/core/hooks/useCustomer'
import { Spinner, Button } from 'lib/ui/components'
import { useSubscriptionOrders } from 'hooks/subscriptions'
import { Heading } from '../../components/Heading'

const LIVBRITE_EMAIL = 'hello@livbritetoday.com'
const SOFIA_EMAIL = 'info@sofiaandgrace.com'
export interface subscriptionItem {
  frequency?: string
  quantity?: string
  sku?: string
}

const STATUS = {
  T: 'Canceled',
  H: 'Paused',
  A: 'Active'
}

export const Details = () => {
  const params = useParams<{ id: string, sku: string }>()
  const { isLivBrite } = useStoreView()
  const { addresses } = useCustomer()
  const [subscriptionItemsChanges, setSubscriptionItemsChanges] = useState<subscriptionItem[]>([])
  const { id: subscriptionId, sku } = params
  const { loading, subscriptionOrder, handleUpdate } = useSubscriptionOrders(subscriptionId, sku)

  const defaultShippingAddress = addresses.find(address => address.isDefaultShipping)
  const { firstName, lastName, street, city, postalCode, regionLabel } = defaultShippingAddress ?? {}
  const orderStatus: 'H' | 'T' | 'A' | undefined = subscriptionOrder?.status
  const status = orderStatus && STATUS[orderStatus]
  const isPaused = status === 'Paused'
  const pausedStatus: string = isPaused ? 'A' : 'H'
  const contactEmail = isLivBrite ? LIVBRITE_EMAIL : SOFIA_EMAIL

  const handleSubmitChange = (status: string) => {
    forEach(subscriptionItemsChanges, function (item) {
      handleUpdate({
        frequency: parseInt(item?.frequency ?? ''),
        quantity: parseInt(item?.quantity ?? ''),
        status
      })
    })
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Heading />
      {!subscriptionOrder && !loading ? (
        <p>Nothing here yet!</p>
      ) : (
        <div className='subscription'>
          <div className='subscription__data'>
            <div className='subscription__data__shipping'>
              <div>
                <p><strong>Ship to</strong></p>
                <div className='current-address'>
                  <p>{firstName} {lastName}</p>
                  <p>{street}</p>
                  <p>{[city, regionLabel, postalCode].join(', ')}</p>
                </div>
              </div>
            </div>
            <div>
              <p><strong>Subscription Status</strong></p>
              <div>
                <p>
                  {status}
                </p>
              </div>
            </div>
          </div>
          <ProductItem
            key={subscriptionId}
            subscriptionProduct={subscriptionOrder}
            subscriptionItemsChanges={subscriptionItemsChanges}
            setSubscriptionItemsChanges={setSubscriptionItemsChanges}
          />
          <div className='subscription__action'>
            <h2>Your next shipment will be updated.</h2>
            <div>
              <Button
                onClick={() => handleSubmitChange('T')}
                className='cancel'
              >
                Cancel Subscription
              </Button>
              <Button
                onClick={() => handleSubmitChange(`${pausedStatus}`)}
                className='pause'
              >
                {isPaused ? 'Unpause Subscription' : 'Pause Subscription'}
              </Button>
              <Button
                onClick={() => handleSubmitChange('A')}
              >
                Save Subscription Changes
              </Button>
            </div>
          </div>
          <p className='subscription__bottom-note'>
            Questions about your subscription? <a href={`mailto:${contactEmail}`}>Email us at {contactEmail}</a>
          </p>
        </div>
      )}
    </>
  )
}
